import { createRouter, createWebHashHistory, Router } from 'vue-router';
import { DateTime } from 'luxon';

// Components
import CalendarMonth from "./components/CalendarMonth.vue";
import ActivityList from "./components/ActivityList.vue";
import CalendarNavigator from "./components/CalendarNavigator.vue";
import { CalendarAppParamType } from './composables/application-parameter';


export const createCalendarRouter = (initParam: CalendarAppParamType): Router => {
  const routerHistory = createWebHashHistory(); // HTML5 interferes with Umbraco routing
  return createRouter({
    history: routerHistory,
    routes: [
      {
        path: '/:year(\\d\\d\\d\\d)/:month(\\d\\d?)',
        name: 'Month',
        components: {
          default: CalendarMonth,
          dayNavigation: CalendarNavigator
        },
        props: {
          default: (route) => ({
            year: Number(route.params.year),
            month: Number(route.params.month)
          }),
          dayNavigation: () => {
            // By month display the navigator as current day only without lateral navigation
            const dt = DateTime.now().setZone(initParam.timeZoneName);
            return {
              year: dt.year,
              month: dt.month,
              day: dt.day,
              isByTime: false
            };
          }
        }
      },
      {
        path: '/:year(\\d\\d\\d\\d)/:month(\\d\\d?)/:day(\\d\\d?)/ByActivity',
        name: 'DayByActivity',
        components: {
          default: ActivityList,
          dayNavigation: CalendarNavigator
        },
        props: {
          default: (route) => ({
            year: Number(route.params.year),
            month: Number(route.params.month),
            day: Number(route.params.day),
            isByTime: false
          }),
          dayNavigation: (route) => ({
            year: Number(route.params.year),
            month: Number(route.params.month),
            day: Number(route.params.day),
            isByTime: false
          })
        }
      },
      {
        path: '/:year(\\d\\d\\d\\d)/:month(\\d\\d?)/:day(\\d\\d?)/ByTime',
        name: 'DayByTime',
        components: {
          default: ActivityList,
          dayNavigation: CalendarNavigator
        },
        props: {
          default: (route) => ({
            year: Number(route.params.year),
            month: Number(route.params.month),
            day: Number(route.params.day),
            isByTime: true
          }),
          dayNavigation: (route) => ({
            year: Number(route.params.year),
            month: Number(route.params.month),
            day: Number(route.params.day),
            isByTime: true
          })
        }
      },
      {
        path: '/Today/ByActivity',
        name: 'TodayByActivity',
        components: {
          default: ActivityList,
          dayNavigation: CalendarNavigator
        },
        props: {
          default: () => {
            const dt = DateTime.now().setZone(initParam.timeZoneName);

            return {
              yeyear: dt.year,
              month: dt.month,
              day: dt.day,
              isByTime: false
            };
          },
          dayNavigation: () => {
            const dt = DateTime.now().setZone(initParam.timeZoneName);

            return {
              year: dt.year,
              month: dt.month,
              day: dt.day,
              isByTime: false
            };
          }
        }
      },
      {
        path: '/Today/ByTime',
        name: 'TodayByTime',
        components: {
          default: ActivityList,
          dayNavigation: CalendarNavigator
        },
        props: {
          default: () => {
            const dt = DateTime.now().setZone(initParam.timeZoneName);

            return {
              year: dt.year,
              month: dt.month,
              day: dt.day,
              isByTime: true
            };
          },

          dayNavigation: () => {
            const dt = DateTime.now().setZone(initParam.timeZoneName);

            return {
              year: dt.year,
              month: dt.month,
              day: dt.day,
              isByTime: true
            };
          }
        }
      },
      {
        path: '/:year(\\d\\d\\d\\d)/:month(\\d\\d?)/:day(\\d\\d?)',
        name: 'Day',
        redirect: to => ({
          name: "DayByTime",
          params: {
            year: to.params.year,
            month: to.params.month,
            day: to.params.day
          }
        })
      },
      {
        path: '/Today',
        name: 'Today',
        redirect: () => ({
          name: "TodayByTime"
        })
      },
      {
        path: '/:pathMatch(.*)',
        redirect: () => {
          const dt = DateTime.now().setZone(initParam.timeZoneName);
          return {
            name: "Month",
            params: {
              year: dt.year,
              month: dt.month
            }
          };
        }
      }
    ]
  });
}